// @flow
import React, { type Node } from 'react';
import classNames from 'classnames/bind';

import nope from 'app/common/lib/nope';
// import IconCross from 'app/common/icons/IconCrossBu';
import PlainButtonAsLink from 'app/common/ui-next/plain-button-as-link';
import PlainIcon, { iconTypes, colorTypes } from 'app/common/ui-next/plain-icon';

import { Inc, Dec } from './QuantityControls';
import styles from './QuantityControl.module.scss';;


const cx = classNames.bind(styles);

type Props = {
  className?: string,
  n: number,
  onClickPlus: (e: SyntheticEvent<HTMLElement>) => void,
  onClickMinus: (e: SyntheticEvent<HTMLElement>) => void,
  onClickCross: (e: SyntheticEvent<HTMLElement>) => void,
  incDisabled: boolean,
}

const QuanttityControl = ({
  className,
  n,
  onClickPlus,
  onClickMinus,
  onClickCross,
  incDisabled,
}: Props): Node => (
  <div className={cx(styles.quantity, className)}>
    <a href="inc" onClick={incDisabled ? nope : onClickPlus}>
      <Inc className={cx(styles.con, { disabled: incDisabled })} />
    </a>

    <div className={styles.num}>{n}</div>

    {n > 1
      ? <PlainButtonAsLink onClick={onClickMinus}>
        <Dec className={styles.con} onClick={onClickMinus} />
      </PlainButtonAsLink>

      : <PlainButtonAsLink onClick={onClickCross}>
        <PlainIcon
          type={iconTypes.CROSS_BOLD}
          className={styles.iconCross}
          width={14}
          height={14}
        />
      </PlainButtonAsLink>}
  </div>
);

export default QuanttityControl;
